import { Button } from "../Button";
import { Container } from "../Container";

import "../../styles/hero.css";
import { siteSettings } from "../../settings";

export function Hero() {
  return (
    <section className="hero-section relative isolate overflow-hidden">
      <div className="hero-media" aria-hidden="true">
        <video
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source src="/bg-video.mp4" type="video/mp4" />
        </video>
        <div className="hero-overlay" />
        <div className="hero-fade" />
      </div>

      <Container className="relative z-10 pb-60 pt-20 text-center lg:pt-32">
        <h1 className="mx-auto max-w-4xl font-sans text-4xl font-semibold tracking-tight text-white sm:text-7xl hero_text ">
          <span> {""} Revolutionizing</span>
          <span> {""} your</span>
          <span> {""} digital</span>
          <span> {""} trading</span>
          <span> {""} experience </span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-[18px] tracking-tight text-[#CECFD1] hero_support">
          Seamlessly merging complexity with ease, {siteSettings.name} offers
          top-notch security, 24/7 support, and an intuitive platform for your
          trading needs.
        </p>
        <div className="mt-10 flex justify-center gap-x-6 hero_buttons">
          <Button href={`${siteSettings.appLink}/register`}>Get started</Button>
          <Button href={`${siteSettings.appLink}/login`} variant="outline">
            <span>Log in</span>
          </Button>
        </div>
      </Container>
    </section>
  );
}
